import type * as React from 'react'

/**
 * Keyboard activation for a DataTable row that opens something.
 *
 * Enter activates every row. Space activates too, but only where the table has
 * no selection column: there Space ticks the row's checkbox, and one key cannot
 * both open the row and select it. Both keys count only when the row itself
 * has focus, so a button inside a cell (a row-actions menu, its items) keeps
 * its own Enter and Space: Enter on "Rename" must rename, not leave the page
 * (b557). When a key activates, its default is cancelled: for Space the page
 * scrolling, for Enter the click it would give the control the row opened.
 */
function handleRowKeyDown(
  event: React.KeyboardEvent<HTMLElement>,
  activate: () => void,
  hasSelectionColumn: boolean,
): void {
  if (event.target !== event.currentTarget) return
  if (event.key === 'Enter') {
    // Cancelled so the Enter cannot go on to activate whatever the row opened:
    // a drawer or dialog moves focus to its close button during this keydown,
    // and the browser turns the uncancelled Enter into a click on that button.
    event.preventDefault()
    activate()
    return
  }
  if (event.key === ' ' && !hasSelectionColumn) {
    event.preventDefault()
    activate()
  }
}

export { handleRowKeyDown }
